import { collectCss } from '../../../../../../internal/style-injector/src/index.mjs';

var css$4 = ".RecoveryCodeEntryScreen_module_input__0b7ea085.RecoveryCodeEntryScreen_module_input__0b7ea085{font-family:var(--st-font-family-mono)}";
collectCss(css$4);
var modules_6bfdbc37 = {"input":"RecoveryCodeEntryScreen_module_input__0b7ea085"};

export { css$4 as css, modules_6bfdbc37 as default };
//# sourceMappingURL=RecoveryCodeEntryScreen.module.css.mjs.map
